"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantCouponsContract = void 0;
const contract_1 = require("../base/contract");
const coupons_schemas_1 = require("../../schemas/merchant/coupons.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantCouponsContract = (0, contract_1.createContract)({
    name: 'MerchantCoupons',
    baseUrl: '/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        listCoupons: {
            method: 'GET',
            path: '/:merchantId/coupons',
            body: null,
            query: coupons_schemas_1.listCouponsQuerySchema,
            params: coupons_schemas_1.listCouponsParamsSchema,
            headers: null,
            response: {
                success: coupons_schemas_1.listCouponsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'List merchant coupons',
                description: 'Retrieves paginated list of merchant coupons with filtering options.',
                tags: ['Merchant', 'Coupons'],
                deprecated: false,
            },
            tests: [
                'should return paginated coupons',
                'should filter by status',
                'should return empty list for merchant with no coupons',
            ],
        },
        getCoupon: {
            method: 'GET',
            path: '/:merchantId/coupons/:couponId',
            body: null,
            query: null,
            params: coupons_schemas_1.getCouponParamsSchema,
            headers: null,
            response: {
                success: coupons_schemas_1.getCouponResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Get coupon details',
                description: 'Retrieves full coupon details including analytics for modal view.',
                tags: ['Merchant', 'Coupons'],
                deprecated: false,
            },
            tests: [
                'should return coupon details with analytics',
                'should include top sharers',
                'should return 404 for non-existent coupon',
            ],
        },
        createCoupon: {
            method: 'POST',
            path: '/:merchantId/coupons',
            body: coupons_schemas_1.createCouponBodySchema,
            query: null,
            params: coupons_schemas_1.createCouponParamsSchema,
            headers: null,
            response: {
                success: coupons_schemas_1.createCouponResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:admin'],
            documentation: {
                summary: 'Create and distribute coupon',
                description: 'Creates a new coupon with required distributions. Coupon is LOCKED (distributed_at set) immediately after creation. Cannot create a coupon without distributing it.',
                tags: ['Merchant', 'Coupons'],
                deprecated: false,
            },
            tests: [
                'should create percentage coupon with distributions',
                'should create fixed amount coupon with distributions',
                'should create free item coupon with distributions',
                'should set commission basis points',
                'should validate coupon_value is positive',
                'should reject request without distributions',
                'should return total_instances_created and member_count',
            ],
        },
        // ============================================
        // V2 ENDPOINTS (uncomment when ready)
        // ============================================
        /*
        updateCoupon: {
            method: 'PATCH',
            path: '/:merchantId/coupons/:couponId',
            body: updateCouponBodySchema,
            query: null,
            params: updateCouponParamsSchema,
            headers: null,
            response: {
                success: updateCouponResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                    forbidden: baseErrorResponseSchema,
                    notFound: baseErrorResponseSchema,
                    validationError: baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:admin'],
            documentation: {
                summary: 'Update coupon',
                description: 'Updates coupon details. Core values (type, value, minimum) locked after distribution (FR35).',
                tags: ['Merchant', 'Coupons'],
                deprecated: false,
            },
            tests: [
                'should update title and description',
                'should update visual design',
                'should return 403 when modifying locked fields after distribution',
            ],
        },
        deleteCoupon: {
            method: 'DELETE',
            path: '/:merchantId/coupons/:couponId',
            body: null,
            query: null,
            params: deleteCouponParamsSchema,
            headers: null,
            response: {
                success: deleteCouponResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                    forbidden: baseErrorResponseSchema,
                    notFound: baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:admin'],
            documentation: {
                summary: 'Delete coupon',
                description: 'Soft deletes a coupon. Only allowed if not yet distributed.',
                tags: ['Merchant', 'Coupons'],
                deprecated: false,
            },
            tests: [
                'should delete coupon with no distributions',
                'should return 403 when coupon has been distributed',
            ],
        },
        // REMOVED: createCouponDistribution - distribution is now merged into createCoupon
        // The distributions field is REQUIRED in createCouponBodySchema
        */
    },
});
